module.exports = __webpack_public_path__ + "static/media/danskeheadline-webfont.89b8aa36.woff";